import type { DateValue } from 'react-aria';

import { CalendarDate, getLocalTimeZone } from '@internationalized/date';
import { useMemo } from 'react';

/** Convert a `Date` from the form into the plain year/month/day React Aria works with. Drops any time and time zone. */
const toCalendarDate = (date: Date | null | undefined) =>
  date && !Number.isNaN(date.getTime()) ? new CalendarDate(date.getFullYear(), date.getMonth() + 1, date.getDate()) : null;

/**
 * `useDateFieldState` re-syncs its display value whenever the value's *identity* changes, so handing it a freshly
 * built `CalendarDate` each render loops forever. Keying the conversion on the timestamp keeps it stable.
 */
export const useCalendarDate = (date: Date | null | undefined) => {
  const time = date?.getTime() ?? null;

  return useMemo(() => (time === null ? null : toCalendarDate(new Date(time))), [time]);
};

/** Back to a `Date` at local midnight, which is what the rest of the app expects. */
export const toDate = (value: DateValue | null) => value?.toDate(getLocalTimeZone()) ?? null;
